import { useCallback, useEffect, useState } from "react";

import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { MdRingVolume } from "react-icons/md";

import { getPeerNo } from "@/new_utils";

import AssignModal from "./AssignModal";

export default function IncomingCall() {
  const [filterValue, setFilterValue] = useState("");
  const [showIncomingModal, setShowIncomingModal] = useState(false);
  const [acknowledged, setAcknowledged] = useState(true);

  const [call, setCall] = useState<Nullable<AcdCallEventType>>(null);

  const { t } = useTranslation(["acd", "contacts", "translation"]);

  function toggleIncomingModal() {
    setShowIncomingModal(!showIncomingModal);
    setAcknowledged(showIncomingModal ? acknowledged : true);
  }

  const incomingCallHandler = useCallback((event: IncomingCallEvent) => {
    const peerNo = getPeerNo(event.detail.event);
    if (!peerNo || !event.detail.line) {
      return;
    }

    setAcknowledged(false);
    setCall(event.detail);
    setFilterValue(
      peerNo
        .replace(/^00(?!4)/, "0")
        .replace(/^00/, "+")
        .replace(/^0/, "+49"),
    );
  }, []);

  const callEnded = useCallback(() => {
    setAcknowledged(true);
    setCall(null);
    setFilterValue("");
  }, []);

  useEffect(() => {
    document.addEventListener("tt:incomingCall", incomingCallHandler);
    document.addEventListener("tt:callEnd", callEnded);

    return () => {
      document.removeEventListener("tt:incomingCall", incomingCallHandler);
      document.removeEventListener("tt:callEnd", callEnded);
    };
  }, [callEnded, incomingCallHandler]);

  return (
    <>
      {!!call && (
        <button
          type="button"
          className={clsx("TT-shortcut-incoming-call", { "not-acknowledged": !acknowledged })}
          onClick={toggleIncomingModal}
          title={t("acd:incoming_call.incoming_call")}
        >
          <MdRingVolume />
        </button>
      )}

      {!!call && showIncomingModal && (
        <AssignModal
          show={showIncomingModal}
          toggle={toggleIncomingModal}
          filterValue={filterValue}
          setFilterValue={setFilterValue}
          call={call}
        />
      )}
    </>
  );
}
